// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//
import { marketingSectionStyles } from "@guestsupply/App/Components/Header/MarketingSection";
import { ellipsis, styledScrollbar, xScreen } from "@guestsupply/XDL/Utilities";

import getColor from "@insite/mobius/utilities/getColor";
import { css } from "styled-components";

marketingSectionStyles.wrapper = {
    css: css`
        width: 48%;
        max-width: 496px;
        padding: 16px 22px;
        height: 100%;
        max-height: ${({ headerHeight }: any) => `calc((100vh - ${headerHeight || "140px"}) * 0.8)`};
        overflow-x: hidden;
        ${styledScrollbar(4)}
        ${xScreen("gt", "xl")} {
            width: 496px;
        }
        ${xScreen("lte", "md")} {
            width: 100%;
            max-width: initial;
            padding: 6px 0 24px;
            border: initial;
            height: auto;
            max-height: initial;
        }
    `,
};
marketingSectionStyles.imageWrapper = {
    css: css`
        display: flex;
        justify-content: center;
        width: 450px;
        max-width: 100%;
        margin-bottom: 12px;
        height: 215px;
        &:empty {
            display: none;
        }
        ${xScreen("lte", "md")} {
            height: 156px;
        }
    `,
};
marketingSectionStyles.image = {
    css: css`
        max-width: 100%;
        max-height: 100%;
        height: auto;
        img {
            border-radius: 4px;
            height: auto;
            width: auto;
            max-width: 100%;
            max-height: 100%;
        }
    `,
};

marketingSectionStyles.titleTypography = {
    as: "p",
    variant: "h3",
    color: "text.main",
    css: css`
        margin-bottom: 12px;
        ${ellipsis(2)}
    `,
};
marketingSectionStyles.contentTypography = {
    variant: "p",
    size: 14,
    weight: 400,
    css: css`
        color: ${getColor("text.main")};
        margin: 0;
    `,
};

marketingSectionStyles.detailPagePathButton = {
    css: css`
        margin-top: 20px;
    `,
};
